/** @format */

// import PropTypes from 'prop-types';
import exact from 'prop-types-exact';

const EntChatPagePropTypes = exact({});

export default EntChatPagePropTypes;
